import React, { useContext, useEffect, useState } from "react";
import { DataCollectionService } from "../../HttpService/DataCollectionService";
import { Col } from "react-bootstrap";
import TODIS_FORM from './form';
import TODIS_MAP from './map';
import { UrlServicesId} from "../../.config";
import { useNavigate, useLocation } from "react-router-dom";

const Home = ({ type, permissions }) => {
 
  const [npmRoadId, setNpmRoadId] = useState("");
  const { state } = useLocation();
  const [fullMap, setfullMap] = useState(false);

  const expanding = () => {
    //console.log("expanding from parent");
    setfullMap(!fullMap);
  }
  
  useEffect(() => {
    (async () => {    
     
      const res = await new DataCollectionService("data/load/" + state.requestId).getFormById();
      if (res == null) {
      } else {  
        //console.log(res);   
        //console.log(res[UrlServicesId[type]]);
        setNpmRoadId(res[UrlServicesId[type]]);        
      }
    })();
  }, [])

  return (
    <>
      <Col sm={fullMap ? 12 : 5} className={type == "EUACQUIS"? "hide": ""}>
        <TODIS_MAP expanding={expanding} fullMap={fullMap} routeid={type} requesid={npmRoadId}/>
      </Col>
      <Col sm={type == "EUACQUIS"? 12 : 7} className={fullMap ? "hide" : ""}>
        <TODIS_FORM permissions={permissions} type={type} />
      </Col>
    </>
  );
}

export default Home;